export default __webpack_public_path__ + "bb996f2b962b379b3a3869cd8b86e7d9.png";